import React, { useState, useEffect } from "react";
import { DogiCard } from "zina-dogi-react";
import { Formik, Form, Field } from "formik";
import CircleLoader from "react-spinners/CircleLoader";
import { Input } from "reactstrap";
import { Link } from "react-router-dom";
import { utils } from "~/utils";
import { service } from "../redux";
import logo from "../../assets/imgs/zina-India_BrightBlue.svg";
import nokiaLogo from "../../assets/imgs/NokiaZinaIndia.svg";
import { LoginContainer } from "../components";
import "../components/index.scss";
import background1 from "../../assets/imgs/carrousel/background-BLUE@2x-80.jpg"
import background2 from "../../assets/imgs/carrousel/background-MAGENTA@2x-80.jpg"
import background3 from "../../assets/imgs/carrousel/background-ORANGE@2x-80.jpg"

const backgrounds = [background1, background2, background3];

const getRandomBackground = () => backgrounds[Math.floor(Math.random() * backgrounds.length)];

const PasswordRecovery = (props) => {
    const [waiting_response, setWaiting_response] = useState(false)
    const [error_message, setError_message] = useState(null)
    const [success_message, setSuccess_message] = useState(null)
    const items = [{ id: 1, src: logo }];
    const [backgroundDefault, setBackgroundDefault] = useState(getRandomBackground());

    useEffect(() => {
        setBackgroundDefault(getRandomBackground())
    }, [])

    const onSubmit = (values, formik) => {
        setWaiting_response(true);
        setError_message(null)
        setSuccess_message(null)
        formik.setSubmitting(true);
        service
            .requestNewPassword(values.username_or_email)
            .then(response => {
                formik.setSubmitting(false);
                setSuccess_message(response.data.detail)
            })
            .catch(response => {
                formik.setSubmitting(false);
                setError_message(utils.computeError(response));
            }).finally(() => setWaiting_response(false))
    };



    return (
        <LoginContainer>
            <DogiCard logo={nokiaLogo} items={items} fondo={backgroundDefault}>
                <Formik className="loginForm" enableReinitialize={true} onSubmit={onSubmit}>
                    {formik => (
                        <div>
                            <Form className="form">
                                <div className="titles titles__zina">
                                    Request a new password
                                </div>
                                {success_message && (
                                    <div className="titles titles__zina text-success">
                                        Success
                                    </div>
                                )}
                                {!success_message && (
                                    <div>
                                        <div className="fields">
                                            <div className="form-group">
                                                <Field
                                                    type="text"
                                                    value={formik.values.username_or_email}
                                                    className="form-control"
                                                    placeholder="Username or email address"
                                                    name="username_or_email"
                                                    required={true}
                                                    component={Input}
                                                    invalid={!!error_message}
                                                    onChange={val => {
                                                        setError_message(null)
                                                        formik.setFieldValue(
                                                            "username_or_email",
                                                            val.target.value,
                                                            false
                                                        );
                                                    }}
                                                />

                                            </div>
                                        </div>
                                        <div className="controls">
                                            <button
                                                type="submit"
                                                className="btn btn-success col"
                                                disabled={formik.isSubmitting}
                                            >
                                                Log in <CircleLoader loading={waiting_response} color={"#007bff"} />
                                            </button>

                                        </div>
                                    </div>
                                )}
                                <Link className="links links__zina" to={`/login/`}>Return to login page</Link>
                                <div className="messages__zina">
                                    <span>{success_message}</span>
                                    {error_message && (
                                        <div>{error_message}</div>
                                    )}
                                </div>
                            </Form>
                        </div>
                    )}
                </Formik>
            </DogiCard>
        </LoginContainer>
    );
}


export default PasswordRecovery;
